import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyChanges: {
        id: 'endorsement.common.view.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    PolicyChangeEfectiveDate: {
        id: 'endorsement.common.views.payment.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    SelectTypeOfChanges: {
        id: 'endorsement.common.view.Select Type of Changes',
        defaultMessage: 'Select Type of Changes'
    },
    SelectTypeOfChanges: {
        id: 'endorsement.common.view.Select Type of Changes',
        defaultMessage: 'Select Type of Changes'
    },
    RenewalEffectiveDateMsgDesc: {
        id: 'endorsement.common.view.Please confirm the policy change are for Renewal policy',
        defaultMessage: 'Please confirm the policy change are for Renewal policy'
    },
    RenewalEffectiveDateMsg: {
        id: 'endorsement.common.view.Review Effective Date Changes',
        defaultMessage: 'Review Effective Date Changes'
    }
});
